import apexchartPolishLanguage from 'helpers/apexchart-pl.language';

export function dateFormatter(date = new Date()): string {
    const month = date.getMonth();
    const year = date.getFullYear();

    return `${apexchartPolishLanguage.options.months[month]} ${year}`;
}
